import React from 'react';
import DatePicker from 'react-datepicker';

import { CustomDatepickerHeader } from '../../../shared/CustomDatepickerHeader';
import CustomTimeInput from '../../../shared/CustomTimeInput';

const WeekPickers = (props) => {
    const {
        begDate,
        setBegDate,
        endDate,
        setEndDate,
        minSelectableDate,
        maxSelectableDate,
        isDisabled,
        hasAsignmentStarted,
        isCreatingInThePast,
    } = props;
    return (
        <div className='form-group'>
            <div className='d-flex justify-content-between align-items-center assignment-editor'>
                <span className='week-date-picker'>
                    <DatePicker
                        renderCustomHeader={(props) => CustomDatepickerHeader(props)}
                        disabled={isDisabled || hasAsignmentStarted}
                        selected={begDate}
                        onChange={setBegDate}
                        dateFormat='ww'
                        customInput={<CustomTimeInput />}
                        showDayMonthPicker
                        minDate={minSelectableDate}
                        maxDate={maxSelectableDate}
                        locale='sv'
                        showWeekNumbers
                    />
                </span>
                <span className='oi oi-arrow-right padding-left-15px padding-right-15px' />
                <span className='week-date-picker'>
                    <DatePicker
                        renderCustomHeader={(props) => CustomDatepickerHeader(props)}
                        disabled={isDisabled}
                        selected={endDate}
                        onChange={setEndDate}
                        dateFormat='ww'
                        customInput={<CustomTimeInput />}
                        showDayMonthPicker
                        minDate={minSelectableDate}
                        maxDate={maxSelectableDate}
                        locale='sv'
                        popperPlacement='bottom-end'
                        showWeekNumbers
                    />
                </span>
            </div>
            {isCreatingInThePast && <div className='invalid-feedback'>Det går inte att skapa uppdrag bakåt i tiden.</div>}
        </div>
    );
};

export default WeekPickers;
